import Vue from "vue";
import Vuex from "vuex";
import axios from "@/utils/http";
import {
  accountTypeToClientType,
  isApiSuccess,
  mapPlanListFromApi,
  mapSubscriptionPlanMeta,
  mapUserSubscriptionInfo,
  normalizeSubscriptionSeat,
} from "@/utils/subscription";
Vue.use(Vuex);
const { protocol, hostname, origin } = window.location;
// 是否是本地环境
const isLocalhost =  process.env.NODE_ENV === 'development'
// 默认无限画布生成配置
// 本地：manshu-ui 与 comic_ai 不同端口，走 VUE_APP_PROT（默认 3400）
// 部署：跟当前页同源，运行时带上非默认端口（如 :8004）；80/443 时 origin 本身不含端口号
const defaultManshuUiEntry = isLocalhost
  ? `${protocol}//${hostname}:${process.env.VUE_APP_PROT}`
  : `${origin}/canvas/`;

function hasLoginToken() {
  return Boolean(window.localStorage.getItem("token"));
}
	
export default new Vuex.Store({
  state: {
    serverUrl: process.env.VUE_APP_SERVER_URL || "https://api.manyutop.com/",
    logoImage: process.env.VUE_APP_LOGO_IMAGE || "logo-manyu",
    systemName: process.env.VUE_APP_SYSTEM_NAME || "漫域AI",
		isCloseVip: ["logo-shenglianyun", "logo-xinxixi"].includes(process.env.VUE_APP_LOGO_IMAGE) || process.env.VUE_APP_LOCALE !== "zh-CN" ? true : false,
    isYueEdition:
      String(process.env.VUE_APP_LOCALE || "").toLowerCase() === "yue",
    system: process.env.VUE_APP_SYSTEM || process.env.VUE_APP_SYSTEM_NAME || "漫域AI",

    versionName: process.env.VUE_APP_VERSION_NAME || "name", // name: 平台模型，names: 自定义模型
    manshuUiEntry: defaultManshuUiEntry,
    subscriptionAccountType: "personal", // personal: 个人版 enterprise: 企业/团队版
    subscriptionPlans: [],
    subscriptionPlanMeta: {
      activityName: "",
      mainTitle: "",
      subTitle: "",
      endDate: "",
      quotaLimit: 0,
      subscribedCount: 0,
    },
    subscriptionPlansLoading: false,
    userClientType: null,
    userVipType: 0,
    userSubscription: {
      subscribed: false,
      planName: "",
      seats: 1,
      periodType: null,
      sellingPrice: null,
    },
    activeSubscriptionPlan: {
      accountType: "",
      planId: "",
      level: 0,
      cycle: "",
      planName: "",
    },
  },
  mutations: {
    setSubscriptionAccountType(state, accountType) {
      state.subscriptionAccountType = accountType;
    },
    setSubscriptionPlans(state, plans) {
      state.subscriptionPlans = plans;
    },
    setSubscriptionPlanMeta(state, meta) {
      state.subscriptionPlanMeta = {
        ...state.subscriptionPlanMeta,
        ...meta,
      };
    },
    setSubscriptionPlansLoading(state, loading) {
      state.subscriptionPlansLoading = loading;
    },
    setUserClientType(state, clientType) {
      state.userClientType =
        clientType == null ? null : Number(clientType);
    },
    setUserSubscriptionInfo(state, payload = {}) {
      if (payload.vipType != null) {
        state.userVipType = Number(payload.vipType);
      }
      if (
        payload.subscribed != null ||
        payload.planName != null ||
        payload.seats != null ||
        payload.periodType != null ||
        payload.sellingPrice != null
      ) {
        state.userSubscription = {
          ...state.userSubscription,
          ...(payload.subscribed != null && {
            subscribed: Boolean(payload.subscribed),
          }),
          ...(payload.planName != null && { planName: payload.planName }),
          ...(payload.seats != null && {
            seats: normalizeSubscriptionSeat(payload.seats),
          }),
          ...(payload.periodType != null && {
            periodType: Number(payload.periodType),
          }),
          ...(payload.sellingPrice != null && {
            sellingPrice: Number(payload.sellingPrice),
          }),
        };
      }
    },
    setActiveSubscriptionPlan(state, plan) {
      state.activeSubscriptionPlan = {
        ...state.activeSubscriptionPlan,
        ...plan,
      };
    },
  },
  actions: {
    fetchSubscriptionPlans({ commit, state }, clientType) {
      if (!hasLoginToken()) {
        return Promise.resolve([]);
      }

      const resolvedClientType =
        clientType != null
          ? Number(clientType)
          : accountTypeToClientType(state.subscriptionAccountType);

      commit("setSubscriptionPlansLoading", true);
      return axios
        .get(`${state.serverUrl}ytb/subscription/plan/list`, {
          params: { clientType: resolvedClientType },
        })
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.data || {};
            commit("setSubscriptionPlanMeta", mapSubscriptionPlanMeta(data));
            const plans = mapPlanListFromApi(data);
            commit("setSubscriptionPlans", plans);
            return plans;
          }
          commit("setSubscriptionPlans", []);
          return Promise.reject(new Error(res.data.message || "获取套餐失败"));
        })
        .finally(() => {
          commit("setSubscriptionPlansLoading", false);
        });
    },
    fetchUserSubscription({ commit, state }) {
      if (!hasLoginToken()) {
        return Promise.resolve(null);
      }

      return axios
        .get(`${state.serverUrl}ytb/subscription/my/info`)
        .then((res) => {
          if (!isApiSuccess(res.data.code)) {
            return null;
          }
          const info = mapUserSubscriptionInfo(res.data.data || {});
          commit("setUserSubscriptionInfo", {
            ...info,
            vipType: info.subscribed ? 1 : 0,
          });
          return info;
        })
        .catch(() => null);
    },
  },
  modules: {},
});
